import React from 'react';

import { IWidgetPaymentData, TWidgetPlan } from '@entities/widget-shop/model/types';
import { formatPrice } from '@shared/helpers';
import { Flex } from '@shared/ui';

import { PeriodPaymentItem } from '..';
import cls from '../../PaymentWidgetModal.module.css';

interface IPaymentPeriodsProps {
    periodsData: TWidgetPlan[];
    activePeriodPicked: TWidgetPlan['id'];
    onPeriodPick: (id: TWidgetPlan['id']) => void;
    currencySign: IWidgetPaymentData['paymentData']['currencySign'];
}

export const PaymentPeriods = ({
    periodsData,
    activePeriodPicked,
    onPeriodPick,
    currencySign,
}: IPaymentPeriodsProps) => (
    <Flex
        as="ul"
        gap="8px"
        align="stretch"
        justify="start"
        fullWidth
        className={cls.optionsGroupBlock}
    >
        {periodsData?.map((period) => (
            <PeriodPaymentItem
                key={period.id}
                id={period.id}
                title={`${formatPrice(period?.pricePerMonth)} ${currencySign}`}
                displayText={period.displayText}
                activePeriodPickedId={activePeriodPicked}
                onPeriodPick={() => onPeriodPick(period.id)}
            />
        ))}
    </Flex>
);
